import fetch from "../utils/fetch";

/**
 * 批量绑定publisher到member
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Membership_Model_bulk_create
 * @param member_email member email
 * @param publisher_ids publisher id，多个以逗号分隔。
 * @returns {*}
 */
export function bulkCreateMember({ member_email, publisher_ids }) {
  return fetch.post(`users/self/members`, { member_email, publisher_ids });
}

/**
 * 批量修改member的publisher
 * @param memberId member标识
 * @param publisher_ids publisher标识 多个用逗号隔开
 * @returns {*}
 */
export function bulkModifyMember({ memberId, publisher_ids }) {
  return fetch.post(`/users/self/members/${memberId}/publiships`, {
    publisher_ids,
  });
}

/**
 * 修改member信息
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Member_Model_update
 * @param member_id member唯一标示
 * @param new_member_email member邮箱
 * @returns {IDBRequest | Promise<void>}
 */
export function modifyMember({ memberId, new_member_email }) {
  return fetch.put(`users/self/members/${memberId}`, { new_member_email });
}

/**
 * 刪除整个member
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Membership_Model_destroy_0
 * @param id
 */
export function delMember({ id }) {
  return fetch.delete(`users/self/members/${id}`);
}
